module.exports = __webpack_public_path__ + "static/media/vacancyPeriodHint-1.1166b014.jpg";